import {formatDistance, format } from "date-fns";

export const formatSeconds = (value) => {
    return formatDistance(0, value * 1000, { includeSeconds: true })
}

export const formatDateTime = (value) => {
    return value.replace('T', ' ');
}